import type { CreatureOverrunChargesInput, CreatureOverrunChargeValue } from '../types';

export const OVERRUN_ABILITY_ID = '1DC3B3DE-BD4C-B77A-429D-12C7F2B2439D';

function firstCharge(value: CreatureOverrunChargeValue): number | string | null {
    if (typeof value === 'number' || typeof value === 'string' || value === null) return value;
    return value[0] ?? 'NA';
}

function phpInt(value: number | string | null): number {
    if (typeof value === 'number') return Number.isFinite(value) ? Math.trunc(value) : 0;
    if (value === null) return 0;
    const match = value.trimStart().match(/^[+-]?(?:(?:\d+(?:\.\d*)?)|(?:\.\d+))(?:e[+-]?\d+)?/i);
    if (!match) return 0;
    const numeric = Number(match[0]);
    return Number.isFinite(numeric) ? Math.trunc(numeric) : 0;
}

/** Project the finalized Overrun charge pool into the movement-facing computed flag. */
export function compileCreatureOverrunChargesRemaining(input: CreatureOverrunChargesInput): number | null {
    if (!input.hasEncounterCreatureId) return null;
    for (const entry of input.freeAbilities) {
        if (entry.abilityId !== OVERRUN_ABILITY_ID) continue;
        const charges = firstCharge(entry.charges);
        return charges === 'NA' || charges === '' || charges === null ? 1 : phpInt(charges);
    }
    return 0;
}
